import { StateCreator } from 'zustand'

import {
  BrowserTitleComputeInput,
  computeBrowserDocumentTitle,
} from './computeBrowserDocumentTitle'

export type BrowserDocumentTitleState = BrowserTitleComputeInput

const initialTitleState: BrowserDocumentTitleState = {
  staticTitle: null,
  viewLabel: null,
  detailEntityDisplay: null,
  detailDrawerSuffix: null,
}

/** Slice state includes methods on the same object; widen so pick stays type-safe. */
const pickComputeInput = (
  b: BrowserDocumentTitleState & Record<string, unknown>,
): BrowserTitleComputeInput => ({
  staticTitle: b.staticTitle,
  viewLabel: b.viewLabel,
  detailEntityDisplay: b.detailEntityDisplay,
  detailDrawerSuffix: b.detailDrawerSuffix,
})

export type BrowserDocumentTitleSlice = {
  browserDocumentTitle: BrowserDocumentTitleState & {
    /** Clears all title fields; invoked from the router on navigation. */
    resetForNavigation: () => void
    /**
     * Shallow-merges title fields: only provided keys change. Pass `null` to clear a field
     * when switching between static title mode and the composed view-label pattern.
     */
    updateTitle: (partial: Partial<BrowserTitleComputeInput>) => void
    getComputedTitle: () => string
  }
}

export const browserDocumentTitleSlice: StateCreator<
  BrowserDocumentTitleSlice,
  [],
  [],
  BrowserDocumentTitleSlice
> = (set, get) => ({
  browserDocumentTitle: {
    ...initialTitleState,
    resetForNavigation: () => {
      set(s => ({
        browserDocumentTitle: {
          ...s.browserDocumentTitle,
          ...initialTitleState,
        },
      }))
    },
    updateTitle: (partial: Partial<BrowserTitleComputeInput>) => {
      set(s => ({
        browserDocumentTitle: {
          ...s.browserDocumentTitle,
          ...partial,
        },
      }))
    },
    getComputedTitle: () =>
      computeBrowserDocumentTitle(pickComputeInput(get().browserDocumentTitle)),
  },
})
